import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { FiLock } from "react-icons/fi";
import { ROLES } from "../../utils/authRoles";
import LogoPicture from "../../assets/Logo.png";

/* ===== STYLES ===== */
const SidebarWrapper = styled.div`
  background: ${({ theme }) => theme.colors.secondary};
  color: white;
  display: flex;
  flex-direction: column;
  height: 100%;

  /* Desktop fixed sidebar */
  @media (min-width: 992px) {
    position: fixed;
    left: 0;
    top: 60px;
    width: 240px;
    height: calc(100% - 60px);
  }

  /* Mobile drawer */
  @media (max-width: 991px) {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 240px;
    z-index: 1000;
    transform: ${({ open }) =>
      open ? "translateX(0)" : "translateX(-100%)"};
    transition: 0.3s ease;
  }
`;

/* Scrollable menu area */
const MenuArea = styled.div`
  flex: 1; /* take all space above footer */
  overflow-y: auto;
  padding: 20px 20px 0 20px;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    width: 0px;
    background: transparent; /* optional: just to be safe */
  }

  /* Hide scrollbar for Firefox */
  scrollbar-width: none;

  /* Hide scrollbar for IE, Edge */
  -ms-overflow-style: none;
`;

/* Overlay */
const Overlay = styled.div`
  @media (max-width: 991px) {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.3);
    display: ${({ open }) => (open ? "block" : "none")};
    z-index: 999;
  }
`;

const MenuItem = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 18px 0;
  color: white;
  text-decoration: none;
  font-size: 16px;

  &.active {
    color: ${({ theme }) => theme.colors.accent};
    font-weight: bold;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.accent};
  }

  ${({ disabled }) =>
    disabled &&
    `
      opacity: 0.6;
      cursor: not-allowed;
      &:hover { color: white; }
    `}
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;

  img {
    max-width: 200px;
    height: auto;

    @media (max-width: 991px) {
      max-width: 150px;
    }
  }
`;

const LockIcon = styled(FiLock)`
  margin-left: 8px;
  font-size: 16px;
`;

const Footer = styled.div`
  font-size: 11px;
  color: #d1d5db; /* light gray */
  text-align: center;
  padding: 10px 0;

  @media (max-width: 991px) {
    font-size: 10px;
  }
`;

export default function Sidebar({ open, close, role, isPremiumUser }) {
  const isAdmin = role === ROLES.ADMIN;
  const canAccessCustomerReports =
    role === ROLES.ADMIN || role === ROLES.SUB_ADMIN;

  return (
    <>
      <Overlay open={open} onClick={close} />
      <SidebarWrapper open={open}>
        <MenuArea>
          <Logo>
            <img
              src={LogoPicture}
              alt="MAPS Logo"
            />
          </Logo>

          {isAdmin && <MenuItem to="/dashboard" onClick={close}>Dashboard</MenuItem>}

          {canAccessCustomerReports && (
            <>
              <MenuItem to="/customers" onClick={close}>Customers</MenuItem>
              <MenuItem to="/reports" onClick={close}>Reports</MenuItem>
              <MenuItem to="/billing" onClick={close}>Billing</MenuItem>
            </>
          )}

          {isAdmin && (
            <>
              <MenuItem to="/goldloan" onClick={close}>Gold Loans</MenuItem>
              <MenuItem to="/repayments" onClick={close}>Repayments</MenuItem>
              <MenuItem to="/admin/user-roles" onClick={close}>User Roles</MenuItem>
              <MenuItem to="/accounting" onClick={close}>Accounting</MenuItem>
              {/* Premium Links */}
          <MenuItem
            to={isPremiumUser ? "/inventory" : "#"}
            onClick={isPremiumUser ? close : (e) => e.preventDefault()}
            disabled={!isPremiumUser}
          >
            Inventory {!isPremiumUser && <LockIcon />}
          </MenuItem>

          {/* <MenuItem
            to={isPremiumUser ? "/accounting" : "#"}
            onClick={isPremiumUser ? close : (e) => e.preventDefault()}
            disabled={!isPremiumUser}
          >
            Accounting {!isPremiumUser && <LockIcon />}
          </MenuItem> */}

          {/* <MenuItem
            to={isPremiumUser ? "/reports" : "#"}
            onClick={isPremiumUser ? close : (e) => e.preventDefault()}
            disabled={!isPremiumUser}
          >
            Reports {!isPremiumUser && <LockIcon />}
          </MenuItem> */}

          <MenuItem
            to={isPremiumUser ? "/settings" : "#"}
            onClick={isPremiumUser ? close : (e) => e.preventDefault()}
            disabled={!isPremiumUser}
          >
            Settings {!isPremiumUser && <LockIcon />}
          </MenuItem>
            </>
          )}
        </MenuArea>

        <Footer>Design & Developed by Pragan Tech Solutions</Footer>
      </SidebarWrapper>
    </>
  );
}